import GEN from '../../../../assets/general.png';

import {API_ENDPOINT_JSON} from './../../../../config';
import {cbamSection1ExporterAndInstallationProfileTabQuestions, cbamSection1InstallationDetailsTabQuestions, cbamSection1MultiInstallationAndMultiProductMappingTabQuestions, cbamSection1ProductClassificationTabQuestions, cbamSection2ElectricityAndHeatDataTabQuestions, cbamSection2FuelConsumptionTabQuestions, cbamSection2ProductionDataPerProductTabQuestions, cbamSection2RawMaterialInputDataTabQuestions, cbamSection3CombustionEmissionsKilnFuelsTabQuestions, cbamSection3OtherProcessEmissionsTabQuestions, cbamSection3ProcessEmissionsCalcinationTabQuestions, cbamSection4CaptiveElectricityTabQuestions, cbamSection4HeatSteamConsumptionTabQuestions, cbamSection4PurchasedElectricityTabQuestions, cbamSection5ClinkerUsedAsPrecursorInCementTabQuestions, cbamSection5PrecursorInputTabQuestions, cbamSection6DataQualityLevelsTabQuestions, cbamSection6MethodologySelectionTabQuestions, cbamSection6ThirdPartyVerificationTabQuestions, cbamSection7DocumentAttachmentsTabQuestions, cbamSection7ExportBatchEmissionAssignmentTabQuestions, cbamSection7ProductLevelEmissionSummaryTabQuestions} from './cbamTabs';

export const cbamSection1ExporterAndInstallationProfileQuestions = {
    header: {
      imageUrl: GEN,
      title: 'SECTION 1 — Exporter & Installation Profile',
      description: `Collects legal, organisational, and plant-level details of the exporter and installation.
                   Ensures traceability of the manufacturing site, product portfolio, and responsible CBAM contacts.`,
      noOfModules: 6,
      answeredQuestions: 16,
      totalQuestions: 65
    },
    APIRoute: API_ENDPOINT_JSON.ESG.CBAM.section1ExporterAndInstallationProfile,
    tabs: [
      {
        id: 'exporterEntityInformation',
        title: '1.1 Exporter Entity Information',
        questions: cbamSection1ExporterAndInstallationProfileTabQuestions,
        accordion: false
      },
      {
        id: 'installationDetails',
        title: '1.2 Installation Details',
        questions: cbamSection1InstallationDetailsTabQuestions,
        accordion: false
      },
      {
        id: 'productClassification',
        title: '1.3 Product Classification',
        questions: cbamSection1ProductClassificationTabQuestions,
        accordion: false
      },
      {
        id: 'multiInstallationAndMultiProductMapping',
        title: '1.4 Multi-Installation & Multi-Product Mapping',
        questions: cbamSection1MultiInstallationAndMultiProductMappingTabQuestions,
        accordion: false
      }
    ]
  };  
  
  export const cbamSection2ActivityDataAndProductionSystemBoundaryQuestions = {
    header: {
      imageUrl: GEN,
      title: 'SECTION 2 — Activity Data & Production System Boundary',
      description: `Captures production quantities, raw materials, fuels, and system boundary definitions.
                   Provides the foundational activity data required for accurate
                    Scope 1 & Scope 2 emission calculations.`,
      noOfModules: 6,
      answeredQuestions: 16,
      totalQuestions: 65
    },
    APIRoute: API_ENDPOINT_JSON.ESG.CBAM.section2ActivityDataAndProductionSystemBoundary,
    tabs: [
      {
        id: 'productionDataPerProduct',
        title: '2.1 Production Data (Per Product)',
        questions: cbamSection2ProductionDataPerProductTabQuestions,
        accordion: false
      },
      {
        id: 'rawMaterialInputData',
        title: '2.2 Raw Material Input Data',
        questions: cbamSection2RawMaterialInputDataTabQuestions,
        accordion: false
      },
      {
        id: 'fuelConsumption',
        title: '2.3 Fuel Consumption',
        questions: cbamSection2FuelConsumptionTabQuestions,
        accordion: false
      },
      {
        id: 'electricityAndHeatData',
        title: '2.4 Electricity & Heat Data',
        questions: cbamSection2ElectricityAndHeatDataTabQuestions,
        accordion: false
      }
    ]
  }; 


  export const cbamSection3DirectEmbeddedEmissionsScope1Questions = {
    header: {
      imageUrl: GEN,
      title: 'SECTION 3 — Direct Embedded Emissions (Scope 1)',
      description: `Records all process (calcination), combustion (fuels), and CKD-related emissions from the plant.
                   Delivers the plant’s direct CO₂ emissions essential for calculating 
                   embedded emissions in CBAM goods.`,
      noOfModules: 6,
      answeredQuestions: 16,
      totalQuestions: 65
    },
    APIRoute: API_ENDPOINT_JSON.ESG.CBAM.section3DirectEmbeddedEmissionsScope1,
    tabs: [
      {
        id: 'processEmissionsCalcination',
        title: '3.1 Process Emissions (Calcination)',
        questions: cbamSection3ProcessEmissionsCalcinationTabQuestions,
        accordion: false
      },
      {
        id: 'combustionEmissionsKilnFuels',
        title: '3.2 Combustion Emissions (Kiln Fuels)',
        questions: cbamSection3CombustionEmissionsKilnFuelsTabQuestions,
        accordion: false
      },
      {
        id: 'otherProcessEmissions',
        title: '3.3 Other Process Emissions',
        questions: cbamSection3OtherProcessEmissionsTabQuestions,
        accordion: false
      }
    ]
  }; 

  export const cbamSection4IndirectEmbeddedEmissionsElectricityQuestions = {
    header: {
      imageUrl: GEN,
      title: 'SECTION 4 — Indirect Embedded Emissions (Electricity)',
      description: `Captures electricity, captive power, and heat/steam consumption along with emission factors.
Determines all indirect energy-related emissions that contribute to product-level embedded CO₂.`,
      noOfModules: 6,
      answeredQuestions: 16,
      totalQuestions: 65
    },
    APIRoute: API_ENDPOINT_JSON.ESG.CBAM.section4IndirectEmbeddedEmissionsElectricity,
    tabs: [
      {
        id: 'purchasedElectricity',
        title: '4.1 Purchased Electricity',
        questions: cbamSection4PurchasedElectricityTabQuestions,
        accordion: false
      },
      {
        id: 'captiveElectricity',
        title: '4.2 Captive Electricity (If any)',
        questions: cbamSection4CaptiveElectricityTabQuestions,
        accordion: false
      },
      {
        id: 'heatSteamConsumption',
        title: '4.3 Heat/Steam Consumption',
        questions: cbamSection4HeatSteamConsumptionTabQuestions,
        accordion: false
      }
    ]
  }; 

  export const cbamSection5PrecursorEmissionsQuestions = {
    header: {
      imageUrl: GEN,
      title: 'SECTION 5 — Precursor Emissions',
      description: `Collects embedded emissions from internal clinker and external precursors (slag, fly ash, etc.).
Ensures precursor-level CO₂ is properly included in total product emissions as per CBAM rules.`,
      noOfModules: 6,
      answeredQuestions: 16,
      totalQuestions: 65
    },
    APIRoute: API_ENDPOINT_JSON.ESG.CBAM.section5PrecursorEmissions,
    tabs: [
      {
        id: 'clinkerUsedAsPrecursorInCement',
        title: '5.1 Clinker Used as Precursor in Cement',
        questions: cbamSection5ClinkerUsedAsPrecursorInCementTabQuestions,
        accordion: false
      },
      {
        id: 'externalPrecursorInputs',
        title: '5.2 External Precursor Inputs',
        questions: cbamSection5PrecursorInputTabQuestions,
        accordion: false
      }
    ]
  }; 


  export const cbamSection6MethodologyDataQualityVerificationQuestions = {
    header: {
      imageUrl: GEN,
      title: 'SECTION 6 — Methodology, Data Quality, Verification',
      description: `Documents selected calculation methods, data quality levels (QL1–QL3), 
                    and any third-party verification.
                    Validates the reliability and compliance of emission data used in CBAM reporting.`,
      noOfModules: 6,
      answeredQuestions: 16,
      totalQuestions: 65
    },
    APIRoute: API_ENDPOINT_JSON.ESG.CBAM.section6MethodologyDataQualityVerification,
    tabs: [
      {
        id: 'methodSelection',
        title: '6.1 Method Selection (Default / Actual / ETS)',
        questions: cbamSection6MethodologySelectionTabQuestions,
        accordion: false
      },
      {
        id: 'dataQualityLevels',
        title: '6.2 Data Quality Levels (QL1, QL2, QL3)',
        questions: cbamSection6DataQualityLevelsTabQuestions,
        accordion: false
      },
      {
        id: 'thirdPartyVerification',
        title: '6.3 Third-Party Verification',
        questions: cbamSection6ThirdPartyVerificationTabQuestions,
        accordion: false
      }
    ]
  }; 


  export const cbamSection7EmissionSummaryAndExportSpecificOutputQuestions = {
    header: {
      imageUrl: GEN,
      title: 'SECTION 7 — Emission Summary & Export-Specific Output',
      description: `Generates final product emission intensities and assigns them to EU export batches.
Produces the CBAM-ready output package that EU importers need for their CBAM declaration.`,
      noOfModules: 6,
      answeredQuestions: 16,
      totalQuestions: 65
    },
    APIRoute: API_ENDPOINT_JSON.ESG.CBAM.section7EmissionSummaryAndExportSpecificOutput,
    tabs: [
      {
        id: 'productLevelEmissionSummary',
        title: '7.1 Product-Level Emission Summary',
        questions: cbamSection7ProductLevelEmissionSummaryTabQuestions,
        accordion: false
      },
      {
        id: 'exportBatchEmissionAssignment',
        title: '7.2 Export Batch Emission Assignment',
        questions: cbamSection7ExportBatchEmissionAssignmentTabQuestions,
        accordion: false
      },
      {
        id: 'documentAttachments',
        title: '7.3 Document Attachments',
        questions: cbamSection7DocumentAttachmentsTabQuestions,
        accordion: false
      }
    ]
  }; 